__turbopack_context__.v({
  "fade-in": "SubNav-module-scss-module__bUHopa__fade-in",
  "subNav": "SubNav-module-scss-module__bUHopa__subNav",
  "subNavGroupTrigger": "SubNav-module-scss-module__bUHopa__subNavGroupTrigger",
  "subNavGroupTriggerActive": "SubNav-module-scss-module__bUHopa__subNavGroupTriggerActive",
  "subNavHeading": "SubNav-module-scss-module__bUHopa__subNavHeading",
  "subNavLeft": "SubNav-module-scss-module__bUHopa__subNavLeft",
});
